export * from './api/contentful';
export * from './api/interfaces';
export * from './api/mappers';
import Footer from './Footer';
export { default as theme } from './theme';
export { default as exampleData } from './data';
export default Footer;